import React from "react";
import { Link } from "react-router-dom";

const Error404 = () => {
    return(
        <section className="error-sec vh-100 d-flex align-items-center">
            <div className="container">
                <div className="error-inner text-center">
                    <h2>404</h2>
                    <h3>Oops ! Page Not Found !</h3>
                    <p>The page you requested does not exist. Click here to back.</p>
                    <Link to={"/"} className="btn back-btn"> Back To Home </Link>
                </div> 
            </div> 
        </section>
    )
}

export default Error404;